import { CloudDownload as DownloadIcon } from "@mui/icons-material";
import { Fab as FloatingActionButton } from "@mui/material";
import { useState } from "react";
import { getOrderProductsCsv } from "../ordersApi";
import CsvExportDialog from "./CsvExportDialog";

const OrderProductsCsvExport = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <div>
      <FloatingActionButton title="Produkty" onClick={() => setDialogOpen(true)}>
        <DownloadIcon />
      </FloatingActionButton>
      <CsvExportDialog
        title="Pobierz produkty"
        filename="produkty.csv"
        downloadErrorMessage="Nie udało się pobrać pliku CSV z produktami"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onDownload={getOrderProductsCsv}
      />
    </div>
  );
};

export default OrderProductsCsvExport;
